<template>
    <!-- 题库管理 列表页 -->
    <div class="board">
        <div v-hasPermi="['questionBank:bank:list']">
            <div class="title">
                <span class="name">{{ questionBankTextConfig.title }}</span>
                <el-button v-hasPermi="['questionBank:bank:add']" type="primary" @click=";(editDialogVisible = true), (row = null)">
                    {{ questionBankTextConfig.create }}</el-button>
            </div>
            <el-form :inline="true" :model="form" ref="form">
                <el-form-item>
                    <el-input v-model="form.name" clearable :placeholder="searchTextConfig.name"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-select v-model="form.status" clearable :placeholder="searchTextConfig.status">
                        <el-option
                            v-for="item in statusOptions"
                            :key="item.dict_value"
                            :label="item.dict_label"
                            :value="item.dict_value">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="search(1)">{{ searchTextConfig.select }}</el-button>
                    <el-button @click="reset">{{ searchTextConfig.reset }}</el-button>
                </el-form-item>
            </el-form>
            <el-table
                :data="tableData"
                v-loading="loading"
                element-loading-text="加载中"
                element-loading-spinner="el-icon-loading"
                ref="multipleTable"
                stripe
                size="medium"
                :height="height"
                style="width:100%">
                <el-table-column prop="name" :label="tableTextConfig.name" :min-width="flexColumnWidth('name', 4, tableData)" show-overflow-tooltip></el-table-column>
                <el-table-column prop="question_num" :label="tableTextConfig.questionNum" min-width="50"></el-table-column>
                <el-table-column :label="tableTextConfig.updatedAt" min-width="150px">
                    <template slot-scope="scope">
                        <p>{{ scope.row.updated_by_username }}</p>
                        <p class="updateDate">{{ scope.row.updated_at | formatTime }}</p>
                    </template>
                </el-table-column>
                <el-table-column :label="tableTextConfig.status" min-width="80px">
                    <template slot-scope="scope">
                        <el-tag :type="scope.row.status == 0 ? 'info' : ''">{{ statusFormatter(scope.row.status) }}</el-tag>
                    </template>
                </el-table-column>
                <el-table-column fixed="right" :label="tableTextConfig.operate" min-width="236px">
                    <template slot-scope="scope">
                        <el-button
                            v-hasPermi="['questionBank:question:list']"
                            size="mini"
                            plain
                            type="primary"
                            @click="$router.push({ path: '/question', query: { id: scope.row.id } })">
                            {{ tableButtonTextConfig.details }}
                        </el-button>
                        <el-button
                            v-hasPermi="['questionBank:bank:update']"
                            size="mini"
                            plain
                            type="primary"
                            @click="edit(scope.row)">
                            {{ tableButtonTextConfig.edit.name }}
                        </el-button>
                        <el-button
                            v-hasPermi="['questionBank:bank:delete']"
                            size="mini"
                            plain
                            type="danger"
                            @click="delet(scope.row.id)"
                            :disabled="scope.row.status == 1">
                            {{ tableButtonTextConfig.delete.name }}
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>
            <pagination v-show="tableData.length" :currentPage.sync="form.page_number" :pageSize.sync="form.page_size" :total.sync="total"></pagination>
            <edit-dialog :row="row" :show.sync="editDialogVisible" @close="close"></edit-dialog>
        </div>
    </div>
</template>

<script>
import pagination from '@/components/pagination/pagination.vue'
import editDialog from './dialog/edit.vue'
import {getDict} from "@/api/dict"

export default {
    name: 'questionBank',
    components: {
        editDialog,
        pagination,
    },
    data() {
        return {
            height: 250,
            loading: true,
            form: {
                name: '',
                status: null,
                page_number: 1,
                page_size: 20,
            },
            total: 0,
            statusOptions: [],
            tableData: [],
            editDialogVisible: false,
            row: null,
        }
    },
    computed: {
        questionBankTextConfig() {
            return this.$store.state.global.textConfig.backend.questionBank
        },
        searchTextConfig() {
            return this.questionBankTextConfig.search
        },
        tableTextConfig() {
            return this.questionBankTextConfig.table
        },
        tableButtonTextConfig() {
            return this.tableTextConfig.button
        }
    },
    beforeRouteEnter(to, from, next) {
        if (from.name === 'question') {
            to.meta.isBack = true
        } else {
            to.meta.isBack = false
        }
        next()
    },
    activated() {
        if (!this.$route.meta.isBack) {
            this.reset()
        } else {
            this.$route.meta.isBack = false
            // this.getBorrowList() /*列表重新加载*/
        }
    },
    watch: {
        tableData() {
            if (this.tableData.length == 0) {
                this.height = 120
            } else {
                this.updateHeight()
            }
        },
    },
    created() {
        getDict('question_back_num').then(res => {
            this.statusOptions = res.data
        })
        this.search(1)
    },
    mounted() {
        const that = this
        setTimeout(() => {
            that.updateHeight()
        }, 200)
        window.onresize = () => {
            that.updateHeight()
        }
    },
    methods: {
        search(val) {
            this.loading = true
            if (val) {
                this.form.page_number = val
            }
            this.$store.dispatch('getQuestionList', this.form).then((res) => {
                if (res) {
                    this.loading = false
                    this.tableData = res.data.list
                    this.total = res.data.total
                    this.form.page_number = res.data.pageNumber
                    this.$refs.multipleTable.bodyWrapper.scrollTop = 0
                }
            })
        },
        edit(row) {
            this.row = row
            this.editDialogVisible = true
        },
        delet(id) {
            let deleteTextConfig = this.tableButtonTextConfig.delete
            this.$confirm(deleteTextConfig.message, deleteTextConfig.title, {
                confirmButtonText: deleteTextConfig.ok,
                cancelButtonText: deleteTextConfig.cancel,
                type: 'warning',
            }).then(() => {
                this.$store.dispatch('deleteQuestion', id).then((res) => {
                    this.$message({
                        type: 'success',
                        message: deleteTextConfig.success,
                    })
                    if (this.tableData.length == 1) {
                        let num = this.form.page_number == 1 ? 1 : this.form.page_number - 1
                        this.search(num)
                    } else {
                        this.search()
                    }
                })
            }).catch(() => {})
        },
        reset() {
            this.form = this.$options.data().form
            this.form.page_size = 20
            this.search(1)
        },
        close(data) {
            this.row = null
            this.editDialogVisible = data
        },
        updateHeight() {
            if (document.getElementsByClassName('el-form')[0]) {
                this.height = document.getElementsByClassName('board')[0].clientHeight - document.getElementsByClassName('el-form')[0].clientHeight - 150
                this.height = this.height < 460 ? 460 : this.height
            }
        },
        statusFormatter(val) {
            let already = this.statusOptions.find(item => item.dict_value == val)
            return already ? already.dict_label : ''
        }
    }
}
</script>

<style scoped></style>
